import { EmptyState } from '@gorila-shared-ui/components';
import { StyledHead, StyledHeadCell, StyledTable } from 'baseui/table';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import { EXTENDED_ROUTE_EVENTS_COLUMNS, ROUTE_EVENTS_COLUMNS } from '../../../constants/reports';
import { useStyles } from '../../../hooks/useStyles';
import { HistoricState } from '../../../types/currentState';
import RouteReportRow from './RouteReportRow';
import { selectedReportRowState } from '../../../storage/reports';
import { useResetRecoilState } from 'recoil';
import { useEffect } from 'react';

type Props = {
  states?: HistoricState[];
  extended?: boolean;
};

export function RouteReportTable({ states, extended = false }: Props) {
  const { styles } = useStyles();
  const resetSelectedReportRowState = useResetRecoilState(selectedReportRowState);

  useEffect(() => {
    return () => {
      resetSelectedReportRowState();
    };
  }, []);

  if (!states?.length) {
    return <EmptyState title="No cuenta con registro de posiciones." />;
  }

  return (
    <StyledTable>
      <StyledHead $width={extended ? '850px' : undefined}>
        {(extended ? EXTENDED_ROUTE_EVENTS_COLUMNS : ROUTE_EVENTS_COLUMNS).map((column, index) => (
          <StyledHeadCell
            key={index}
            style={{
              flex: column.size,
              maxWidth: column.maxWidth ? `${column.maxWidth}px` : undefined,
              justifyContent: column.centered ? 'center' : undefined,
              ...styles.smallTableCellHeader,
            }}
          >
            {column.title}
          </StyledHeadCell>
        ))}
      </StyledHead>
      <div style={{ flex: 1, minHeight: '250px', width: extended ? '850px' : undefined }}>
        <AutoSizer>
          {({ width, height }) => (
            <List
              height={height}
              itemCount={states.length}
              itemSize={() => SMALL_LIST_ITEM_HEIGHT}
              width={width}
              itemData={{ states, extended }}
            >
              {RouteReportRow}
            </List>
          )}
        </AutoSizer>
      </div>
    </StyledTable>
  );
}
